var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTowingPana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M605.66,102.51,605,99.66c-5.81-24-24-43.1-47.73-49A63.3,63.3,0,0,0,548,49c-22.57-2.2-46.05,7.94-60.18,26-8.31,10.62-14,24.08-25.51,30.94-15,8.91-34,3.33-50.32-2.44s-35.32-11.31-50.31-2.32c-9.39,5.63-15.11,16.05-17.89,26.7-7.33,28.2,4.11,59.13,24.76,79.26s49.24,30.44,77.86,33.56c40.08,4.38,82.54-5.09,114.31-30.46S611.84,142.75,605.66,102.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.99,
    cy: 99.8,
    r: 45.45,
    transform: "translate(-0.86 197.51) rotate(-45)",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.31,438.87c0,.14-148.34.26-331.29.26S43.69,439,43.69,438.87,192,438.61,375,438.61,706.31,438.73,706.31,438.87Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.72,413.54a4.85,4.85,0,0,1,2.49,2.82,8.66,8.66,0,0,1,.33,3.82,14.91,14.91,0,0,1-3.21,7c-2.08-1.82-2.56-5-2.71-6.62-.22-2.58.93-7.36,3.1-7",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.76,431.23a4.08,4.08,0,0,1,1.32-3.89,5.45,5.45,0,0,1,4-1.26,2.31,2.31,0,0,1,1.76.79,1.77,1.77,0,0,1,0,1.78,3.45,3.45,0,0,1-1.31,1.29c-1.81,1.14-3.77,1.9-5.81,1.29",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.08,438.83a3.76,3.76,0,0,1,.08-.51c.06-.36.15-.82.25-1.38a14.52,14.52,0,0,1,1.42-4.39A8.78,8.78,0,0,1,449,429.2a5.86,5.86,0,0,1,1.29-.57,2.68,2.68,0,0,1,.37-.1l.13,0a9.88,9.88,0,0,0-1.72.8,9,9,0,0,0-3.06,3.33,15.62,15.62,0,0,0-1.46,4.33c-.12.58-.22,1-.3,1.37A2.53,2.53,0,0,1,444.08,438.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.16,417.26a.72.72,0,0,1,0,.23c0,.16,0,.37,0,.64,0,.55.07,1.35.1,2.35.06,2,.11,4.73.1,7.76s-.09,5.77-.17,7.76c0,1-.08,1.8-.11,2.35,0,.26,0,.47-.05.64s0,.22,0,.22a.77.77,0,0,1,0-.22c0-.17,0-.38,0-.64,0-.58,0-1.38.05-2.35.05-2,.11-4.73.12-7.76s0-5.78-.05-7.76c0-1,0-1.77,0-2.35v-.64A2.07,2.07,0,0,1,444.16,417.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.15,432.74a9.59,9.59,0,0,0-5.24-7,2,2,0,0,0-2.18,0,2,2,0,0,0-.16,2.17,8.19,8.19,0,0,0,7.53,5.08",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.25,428.07a2.61,2.61,0,0,1,.45.19,5.28,5.28,0,0,1,.5.27c.18.12.41.23.63.4a7.75,7.75,0,0,1,.73.55,9.64,9.64,0,0,1,.78.7,10.48,10.48,0,0,1,1.47,1.9,10.14,10.14,0,0,1,1,2.19,9.41,9.41,0,0,1,.25,1,8.31,8.31,0,0,1,.12.9,7.05,7.05,0,0,1,0,.76,4.62,4.62,0,0,1,0,.56,2.7,2.7,0,0,1-.05.48s0-.69-.09-1.78a7.88,7.88,0,0,0-.15-.89c-.06-.32-.16-.65-.26-1a10.86,10.86,0,0,0-1-2.15,11.38,11.38,0,0,0-1.44-1.87c-.26-.26-.5-.5-.75-.71s-.49-.39-.71-.56C438.86,428.39,438.23,428.1,438.25,428.07Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.02,
    y: 214.34,
    width: 346.96,
    height: 46.9,
    transform: "translate(984.72 480.24) rotate(-179.46)",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 320.02,
    y: 214.34,
    width: 346.96,
    height: 46.9,
    transform: "translate(984.72 480.24) rotate(-179.46)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M305.68,208.61a28.78,28.78,0,0,1,23.82-18.45l78-8.42,28.62-20a116.65,116.65,0,0,1,67.93-21l152.14,1.44h0l32.7.31a3.19,3.19,0,0,1,1.19,6.14l-13.38,5.57a24.84,24.84,0,0,1,1.32,2.63l7.36,17.52A33.78,33.78,0,0,1,688,187.77a7.62,7.62,0,0,1,7.55,7.69l-.29,30.38,7.87,3.6a10.54,10.54,0,0,1,6.15,9.68l-.08,7.88a12.88,12.88,0,0,1-10.46,12.53l-41.87,8,0-3.78A40.34,40.34,0,0,0,617,223h0a40.36,40.36,0,0,0-40.73,40l0,3.78-167.9-1.59,0-3.78a40.34,40.34,0,0,0-40-40.72h0a40.34,40.34,0,0,0-40.72,40l0,3.77L307,264.18A10.07,10.07,0,0,1,297,254l.21-23Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678,156.76l7.36,17.52A34,34,0,0,1,688,187.77l-10.39-.1-9.88-29.81,8.94-3.73A24.84,24.84,0,0,1,678,156.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.68,208.61a29.18,29.18,0,0,1,2.4-4.89l11.05.11-10.22,23.1-11.69,6.6,0-2.57Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.68,208.61a29.18,29.18,0,0,1,2.4-4.89l11.05.11-10.22,23.1-11.69,6.6,0-2.57Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M694.57,215.57l-5.72,0a16.11,16.11,0,0,1-9.12-3l-9.47-6.7a6.22,6.22,0,0,1-2.63-5.15h0a6.23,6.23,0,0,1,6.29-6.17l20.83.2a.91.91,0,0,1,.9.92l-.16,19A.91.91,0,0,1,694.57,215.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.63,232.49,300,230.6l-2,0a1.21,1.21,0,0,1,0-2.41l6.19.06,2.1-1.18-7.07-.07a1.21,1.21,0,0,1,0-2.41l9.39.09.53-1.2-8.5-.08a1.21,1.21,0,1,1,0-2.41l9.54.09.53-1.2-8.88-.08a1.21,1.21,0,0,1,0-2.41l9.91.1.53-1.2-9.05-.09a1.21,1.21,0,0,1,0-2.41l10.08.1.53-1.2-9.22-.09a1.2,1.2,0,1,1,0-2.4l10.26.09.53-1.2L306,209a1.2,1.2,0,1,1,0-2.4l10.53.1.74-1.67-9.22-.08a1.21,1.21,0,1,1,0-2.41l11,.11a1.2,1.2,0,0,1,1.09,1.69L316.85,212h0l-1.59,3.6h0l-1.59,3.6h0l-1.59,3.59h0l-1.58,3.59h0l-.47,1.06a1.28,1.28,0,0,1-.51.57l-11.7,6.6a1.2,1.2,0,0,1-.6.16,1.22,1.22,0,0,1-1-.62A1.2,1.2,0,0,1,296.63,232.49Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.63,232.49,300,230.6l-2,0a1.21,1.21,0,0,1,0-2.41l6.19.06,2.1-1.18-7.07-.07a1.21,1.21,0,0,1,0-2.41l9.39.09.53-1.2-8.5-.08a1.21,1.21,0,1,1,0-2.41l9.54.09.53-1.2-8.88-.08a1.21,1.21,0,0,1,0-2.41l9.91.1.53-1.2-9.05-.09a1.21,1.21,0,0,1,0-2.41l10.08.1.53-1.2-9.22-.09a1.2,1.2,0,1,1,0-2.4l10.26.09.53-1.2L306,209a1.2,1.2,0,1,1,0-2.4l10.53.1.74-1.67-9.22-.08a1.21,1.21,0,1,1,0-2.41l11,.11a1.2,1.2,0,0,1,1.09,1.69L316.85,212h0l-1.59,3.6h0l-1.59,3.6h0l-1.59,3.59h0l-1.58,3.59h0l-.47,1.06a1.28,1.28,0,0,1-.51.57l-11.7,6.6a1.2,1.2,0,0,1-.6.16,1.22,1.22,0,0,1-1-.62A1.2,1.2,0,0,1,296.63,232.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 615.65,
    cy: 264.99,
    r: 35.16,
    transform: "translate(-18.24 47.2) rotate(-4.33)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.8,264.73s0,.06,0,.09a35.16,35.16,0,0,1-70.32.35s0-.06,0-.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.33,264.87a24.68,24.68,0,1,1-24.8-24.56A24.68,24.68,0,0,1,640.33,264.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.53,240.31a24.67,24.67,0,0,1,24.8,24.56l-49.36.25A24.68,24.68,0,0,1,615.53,240.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.69,264.92a15,15,0,1,1-15.11-15A15,15,0,0,1,630.69,264.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,262.47a35.16,35.16,0,1,1-35.33-35A35.16,35.16,0,0,1,403,262.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,262.38v.09a35.16,35.16,0,1,1-70.31.35v-.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5,262.53A24.69,24.69,0,1,1,367.69,238,24.68,24.68,0,0,1,392.5,262.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.69,238a24.69,24.69,0,0,1,24.81,24.57l-49.37.24A24.69,24.69,0,0,1,367.69,238Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.85,262.57a15,15,0,1,1-15.11-15A15,15,0,0,1,382.85,262.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48,181.74l28.62-20a117,117,0,0,1,26.63-13.88l9.37.09-57.23,37.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.39,201.65l-13.82-.13a33.47,33.47,0,0,1,7.17-6.91C319.91,193.62,323.73,197.62,323.39,201.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.17,188.07l-182.89-1.73,52.55-35.54a22.3,22.3,0,0,1,13.24-4.2l113.38,1.07s40.74-.61,49.56,11.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.61,188.14l-6.46-38.23,21.28.2a68.74,68.74,0,0,1,23.87,4.78l6.4,2.89a6.12,6.12,0,0,1,2.42,9.53l-7.57,9.21a32,32,0,0,1-23.18,11.71c-.66,0-1.33.05-2,.05Zm-84.35-.8.36-38.17,62.67.59L588.72,188Zm-89.58-.85L477,151.83a15.38,15.38,0,0,1,9.25-3l21.67.2-7.7,38.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507,256.67s0-.06,0-.18,0-.31,0-.53c0-.49,0-1.17,0-2,0-1.79,0-4.35,0-7.5,0-6.35,0-15.08-.06-24.73,0-4.83,0-9.43-.07-13.62,0-2.09,0-4.08,0-5.94a33.59,33.59,0,0,1,.23-5.15,35.83,35.83,0,0,1,1.77-7.26c.29-.83.54-1.47.72-1.9.09-.2.15-.36.21-.49l.06-.17s0,.05-.09.16-.14.27-.24.48c-.19.42-.47,1-.78,1.88A34.47,34.47,0,0,0,507,197a31.5,31.5,0,0,0-.27,5.18c0,1.86,0,3.85,0,5.94,0,4.19,0,8.79.05,13.62.06,9.65.11,18.39.15,24.74,0,3.14.06,5.7.08,7.49,0,.87,0,1.55,0,2,0,.22,0,.39,0,.53A1.23,1.23,0,0,0,507,256.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.3,189.14s-.05,0-.14.09l-.42.32-.3.23-.31.34a6.2,6.2,0,0,0-.75.87,23.59,23.59,0,0,0-3.24,6.52c-.5,1.46-1,3.08-1.41,4.85-.21.88-.41,1.79-.59,2.74a14.57,14.57,0,0,0-.25,3c0,4.07.05,8.55.12,13.24.16,9.39.36,17.89.53,24,.09,3.06.16,5.54.21,7.29,0,.84.06,1.5.08,2l0,.51c0,.12,0,.17,0,.17a1,1,0,0,0,0-.17v-.52c0-.47,0-1.14,0-2,0-1.74-.07-4.23-.12-7.28-.11-6.18-.26-14.67-.43-24.05-.07-4.69-.16-9.16-.14-13.22a13.48,13.48,0,0,1,.23-2.94c.17-.94.36-1.86.57-2.73.41-1.76.88-3.38,1.37-4.83a24,24,0,0,1,3.12-6.53A11.28,11.28,0,0,1,428.3,189.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.28,187.84h0a6.29,6.29,0,0,1,3.25-5.45l8.28-4.54a15.63,15.63,0,0,1,7.71-1.94h0a15.71,15.71,0,0,1,4.88.82,8.94,8.94,0,0,1,5.93,8.26h0a9.08,9.08,0,0,1-9.16,9.33l-14.67-.14A6.27,6.27,0,0,1,422.28,187.84Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.28,187.84s0,.28.08.8a6.53,6.53,0,0,0,.71,2.15,6.18,6.18,0,0,0,4.61,3.2,23,23,0,0,0,2.53.07l12.56.08a9.65,9.65,0,0,0,3.51-.54,8.85,8.85,0,0,0,3.12-1.95,8.74,8.74,0,0,0,2.13-3.16,9.06,9.06,0,0,0,.58-3.88,8.93,8.93,0,0,0-3.64-6.61,9.54,9.54,0,0,0-3.39-1.46,15.49,15.49,0,0,0-10,.86c-1,.42-1.83.94-2.69,1.4l-2.47,1.34-4.24,2.3a6.31,6.31,0,0,0-3.29,4.6c-.08.52-.08.8-.1.8a3.55,3.55,0,0,1,0-.81,6.13,6.13,0,0,1,.7-2.2,6.45,6.45,0,0,1,2.57-2.58l4.21-2.35c.79-.43,1.61-.88,2.46-1.36s1.72-1,2.7-1.43a15.79,15.79,0,0,1,6.59-1.38,16.24,16.24,0,0,1,3.63.45,9.72,9.72,0,0,1,3.52,1.52,9.22,9.22,0,0,1,3.81,6.89,9.34,9.34,0,0,1-.61,4,9.23,9.23,0,0,1-5.48,5.31,9.75,9.75,0,0,1-3.63.55l-12.56-.16a23.62,23.62,0,0,1-2.56-.1,6.3,6.3,0,0,1-4.71-3.37,6.14,6.14,0,0,1-.65-2.21A5,5,0,0,1,422.28,187.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.1,179.41s-.22-.29-.7-.69a4.93,4.93,0,0,0-2.42-1,10.53,10.53,0,0,0-3.92.39,29.53,29.53,0,0,0-4.64,1.53,30.46,30.46,0,0,0-7.56,4.6c-1.76,1.45-2.69,2.53-2.75,2.48a4.89,4.89,0,0,1,.63-.78,25.73,25.73,0,0,1,1.94-1.9,28,28,0,0,1,7.59-4.75,27.27,27.27,0,0,1,4.71-1.52,10.12,10.12,0,0,1,4-.31,4.74,4.74,0,0,1,2.47,1.15,3.34,3.34,0,0,1,.49.57Q445.12,179.4,445.1,179.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.44,265.58s0-.14,0-.43,0-.72-.06-1.27-.08-1.25-.08-2.07.05-1.76.08-2.82.21-2.23.33-3.51c.07-.64.22-1.3.33-2s.22-1.42.41-2.15a53.94,53.94,0,0,1,3.24-9.69,52.33,52.33,0,0,1,6.43-10.57,50.13,50.13,0,0,1,10.21-9.82,47.66,47.66,0,0,1,14-6.91A55.57,55.57,0,0,1,616,212a57.83,57.83,0,0,1,16.59,2.78,52.51,52.51,0,0,1,14,7,57.5,57.5,0,0,1,10.48,9.57,61.94,61.94,0,0,1,7,10.18,68.55,68.55,0,0,1,4.17,9.35c.25.7.45,1.41.66,2.07s.43,1.31.59,1.94c.3,1.25.62,2.39.83,3.43s.37,2,.53,2.77.2,1.49.28,2.05.13,1,.17,1.26.07.43.07.43,0-.15,0-.43-.08-.72-.14-1.27-.13-1.25-.26-2.06-.31-1.73-.5-2.78-.51-2.18-.81-3.44c-.14-.63-.37-1.27-.57-2s-.4-1.37-.66-2.08a66,66,0,0,0-4.13-9.4,62.3,62.3,0,0,0-7.05-10.24,57.32,57.32,0,0,0-10.51-9.64,52,52,0,0,0-14.07-7.08A57.83,57.83,0,0,0,616,211.67a55.87,55.87,0,0,0-16.74,2.38,47.88,47.88,0,0,0-14.12,7,50.16,50.16,0,0,0-10.25,9.9,53,53,0,0,0-6.43,10.64,53.89,53.89,0,0,0-3.21,9.75c-.18.73-.26,1.46-.39,2.15s-.26,1.35-.32,2c-.11,1.29-.26,2.46-.3,3.53s0,2,0,2.82.08,1.51.11,2.07.06,1,.09,1.27S564.44,265.58,564.44,265.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.9,213.72s.07-.08.18-.24.28-.43.46-.72c.4-.63,1-1.55,1.61-2.7a45.8,45.8,0,0,0,2.15-4.15,8.05,8.05,0,0,0,.44-1.31,1.9,1.9,0,0,0,0-.75c-.06-.23-.13-.46-.2-.69-.29-.92-.63-1.85-1-2.79-1.48-3.78-3-7.13-4-9.56-.54-1.21-1-2.19-1.31-2.86l-.37-.77a1.11,1.11,0,0,0-.15-.26,1.14,1.14,0,0,0,.09.29c.09.21.19.47.32.79.3.73.71,1.71,1.21,2.9,1,2.45,2.47,5.82,3.94,9.58.37,1,.71,1.87,1,2.77a3,3,0,0,1,.23,1.3,6.93,6.93,0,0,1-.41,1.24c-.69,1.6-1.45,3-2.07,4.16l-1.52,2.75c-.17.3-.3.55-.41.75A.89.89,0,0,0,600.9,213.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.66,226c0,.09,9.84.21,22,.27s22,0,22-.06-9.84-.2-22-.26S651.66,225.89,651.66,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.88,255.31c0,.09,31.92.46,71.29.84s71.31.6,71.31.51-31.92-.46-71.31-.83S421.88,255.23,421.88,255.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,254.51c0,.09,4.89.21,10.92.27s10.92,0,10.92-.06-4.88-.2-10.91-.26S297,254.43,297,254.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.58,197.14h.24l.68,0,2.63-.18c2.29-.17,5.6-.44,9.68-.81,8.16-.73,19.43-1.9,31.83-3.51s23.6-3.38,31.68-4.76c4-.69,7.3-1.27,9.55-1.7l2.6-.49.67-.14.23-.05-.24,0-.67.11-2.61.43-9.57,1.6c-8.09,1.32-19.28,3-31.68,4.66s-23.66,2.82-31.81,3.61l-9.67.9-2.62.25-.69.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.45,202.49a4.49,4.49,0,0,0-.49-.08,3.46,3.46,0,0,1-1.3-.53,3.37,3.37,0,0,1-1.31-1.74,3.77,3.77,0,0,1-.16-1.37,3.45,3.45,0,0,1,.4-1.47,3.3,3.3,0,0,1,2.88-1.72l4.18,0,9.6.11a3.2,3.2,0,0,1,2.17.87,3.23,3.23,0,0,1,1,2,3.7,3.7,0,0,1-.41,2.19,3.36,3.36,0,0,1-1.61,1.4,5.1,5.1,0,0,1-2.06.23h-2l-3.64,0h-5.29l-1.43,0a3.45,3.45,0,0,0-.51,0l.5,0,1.44,0,5.28.1,3.65.06,2,0c.36,0,.7,0,1.08,0a3.24,3.24,0,0,0,1.1-.24,3.52,3.52,0,0,0,1.76-1.52,4,4,0,0,0,.47-2.37,3.58,3.58,0,0,0-3.51-3.21l-9.59-.07-4.19,0a3.51,3.51,0,0,0-3.48,3.45,3.75,3.75,0,0,0,.19,1.44,3.44,3.44,0,0,0,1.41,1.78,3.31,3.31,0,0,0,1.36.5A1.89,1.89,0,0,0,483.45,202.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.7,194.53a45.3,45.3,0,0,0,5.44.22,46.4,46.4,0,0,0,5.44-.12,49.23,49.23,0,0,0-5.43-.21A45.59,45.59,0,0,0,484.7,194.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.85,203.9s-.17,0-.49-.08a3.37,3.37,0,0,1-2.61-2.27,3.77,3.77,0,0,1-.16-1.37,3.38,3.38,0,0,1,.4-1.47,3.28,3.28,0,0,1,2.88-1.71l4.18.05,9.59.1a3.25,3.25,0,0,1,3.2,2.91,3.61,3.61,0,0,1-.42,2.19,3.25,3.25,0,0,1-1.6,1.4,5,5,0,0,1-2.07.23h-12.4a3.37,3.37,0,0,0-.5,0,2.42,2.42,0,0,0,.5,0l1.44,0,5.28.1,3.65.06,2,0c.36,0,.7,0,1.07,0a3.8,3.8,0,0,0,1.11-.24,3.61,3.61,0,0,0,1.76-1.52,4,4,0,0,0,.47-2.38,3.58,3.58,0,0,0-3.51-3.2l-9.6-.08-4.19,0a3.53,3.53,0,0,0-3.07,1.87,3.4,3.4,0,0,0-.4,1.58,3.73,3.73,0,0,0,.19,1.43A3.42,3.42,0,0,0,572,203.4a3.26,3.26,0,0,0,1.36.49A1.89,1.89,0,0,0,573.85,203.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.1,196a49.51,49.51,0,0,0,5.44.21,45.25,45.25,0,0,0,5.44-.11,44,44,0,0,0-5.44-.21A45.36,45.36,0,0,0,575.1,196Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.24,264.39s0-.14,0-.43,0-.72,0-1.27,0-1.25,0-2.06.14-1.76.23-2.81.31-2.22.49-3.49c.09-.64.27-1.29.4-2s.28-1.4.49-2.12a57.58,57.58,0,0,1,3.49-9.59A55.43,55.43,0,0,1,330,230.16a52,52,0,0,1,10.23-9.78,48.3,48.3,0,0,1,14-7,53.58,53.58,0,0,1,33.16.32A48.45,48.45,0,0,1,401.17,221a51.89,51.89,0,0,1,10,10,55.29,55.29,0,0,1,6.36,10.6,58.63,58.63,0,0,1,3.31,9.65c.19.73.3,1.45.45,2.13s.29,1.34.36,2c.16,1.28.35,2.45.43,3.5s.12,2,.17,2.82,0,1.5,0,2.06,0,1,0,1.27,0,.44,0,.44,0-.15,0-.44,0-.72,0-1.27,0-1.25,0-2.07-.09-1.76-.14-2.82-.25-2.22-.4-3.51c-.07-.64-.23-1.3-.35-2s-.25-1.41-.44-2.14a58.09,58.09,0,0,0-3.27-9.71,55.44,55.44,0,0,0-6.36-10.66,52.14,52.14,0,0,0-10.08-10.05,48.5,48.5,0,0,0-13.91-7.32,53.7,53.7,0,0,0-33.35-.31,48.37,48.37,0,0,0-14.05,7A52.29,52.29,0,0,0,329.76,230a55.51,55.51,0,0,0-6.55,10.54,58.32,58.32,0,0,0-3.46,9.64c-.21.73-.32,1.45-.48,2.14s-.31,1.34-.39,2c-.17,1.28-.37,2.45-.47,3.51s-.13,2-.19,2.81,0,1.51,0,2.07,0,1,0,1.27S318.24,264.39,318.24,264.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.26,147.53l.27,0,.81,0,3.1,0,11.39.11,37.59.23,20.7.09c6.36,0,12.1.11,16.91-.12a82.62,82.62,0,0,0,11.33-1.19c1.33-.24,2.35-.46,3-.64l.78-.19a1.62,1.62,0,0,0,.26-.08l-.27.05-.79.16c-.69.15-1.71.35-3,.58A91,91,0,0,1,677,147.7c-4.81.2-10.53.08-16.9.05l-20.69-.11-37.6-.15h-15.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.72,163.32c0,.08,6.59,3.71,14.81,8.11s14.91,7.92,15,7.84-6.59-3.71-14.8-8.12S542.77,163.24,542.72,163.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.81,160.39a1.41,1.41,0,0,0,.32.21l.94.51,3.49,1.88c3,1.57,7,3.77,11.46,6.25s8.47,4.78,11.36,6.45l3.43,2,.94.53a3.33,3.33,0,0,0,.33.17,1.48,1.48,0,0,0-.3-.23l-.91-.57c-.79-.5-1.94-1.21-3.38-2.07-2.86-1.73-6.85-4.06-11.31-6.54s-8.54-4.65-11.52-6.17c-1.48-.77-2.69-1.38-3.53-1.79l-1-.46A3.45,3.45,0,0,0,528.81,160.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.27,164.9s.08.06.26.14l.76.37,2.83,1.29c2.39,1.1,5.67,2.63,9.26,4.41s6.81,3.46,9.13,4.69l2.74,1.46.76.39a.86.86,0,0,0,.27.12,1.47,1.47,0,0,0-.24-.18l-.72-.44c-.63-.37-1.56-.91-2.7-1.55-2.3-1.28-5.5-3-9.1-4.78s-6.9-3.28-9.31-4.32c-1.21-.53-2.19-.94-2.87-1.21l-.79-.31A1.2,1.2,0,0,0,468.27,164.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,164.12a12.63,12.63,0,0,0,1.74.92c1.08.54,2.56,1.31,4.17,2.22s3,1.8,4,2.46a15,15,0,0,0,1.67,1,10.06,10.06,0,0,0-1.54-1.22c-1-.7-2.4-1.63-4-2.55s-3.12-1.65-4.23-2.15A11.21,11.21,0,0,0,477,164.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.56,165.07c0,.08,4.36,1.9,9.81,4.05s9.9,3.84,9.93,3.75-4.36-1.89-9.81-4.05S613.59,165,613.56,165.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.25,163.29c0,.09,3.76,1.59,8.47,3.35s8.55,3.14,8.58,3.06-3.76-1.59-8.47-3.35S619.28,163.21,619.25,163.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.87,209a3.13,3.13,0,0,0,.5,0l1.43-.13,1-.1c.38,0,.79,0,1.23-.06.89,0,1.89-.12,3-.09h1.75c.6,0,1.23.06,1.89.09,1.31,0,2.69.2,4.16.35a61.08,61.08,0,0,1,18.32,5.22c1.32.65,2.59,1.24,3.72,1.89.57.32,1.13.61,1.65.93L401,218c1,.57,1.77,1.17,2.51,1.66.36.26.7.48,1,.71l.82.62,1.15.87a2.62,2.62,0,0,0,.41.28,2.61,2.61,0,0,0-.37-.33l-1.11-.91-.81-.66c-.3-.23-.64-.46-1-.72-.73-.51-1.53-1.13-2.48-1.71l-1.48-.94c-.52-.32-1.08-.61-1.65-.94-1.14-.67-2.41-1.27-3.73-1.92a64.2,64.2,0,0,0-9-3.37,65.6,65.6,0,0,0-9.42-1.88c-1.47-.14-2.86-.3-4.18-.33-.66,0-1.29-.07-1.9-.06h-1.75c-1.12,0-2.12.09-3,.14-.44,0-.85.05-1.23.09l-1,.13-1.43.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.47,209.74l.39,0,1.13,0c.5,0,1.1,0,1.79.06s1.49.07,2.37.17l1.37.14c.47.05,1,.14,1.48.21,1,.12,2.1.35,3.24.56a66.12,66.12,0,0,1,7.28,2c2.54.86,4.9,1.83,7,2.79s4,2,5.48,2.82c.78.42,1.45.84,2.05,1.2s1.11.67,1.53.93l1,.6a1.8,1.8,0,0,0,.35.19,2.21,2.21,0,0,0-.31-.24l-.94-.65c-.4-.28-.9-.62-1.5-1s-1.26-.8-2-1.23c-1.51-.9-3.37-1.89-5.47-2.89a70.37,70.37,0,0,0-7-2.83,65.07,65.07,0,0,0-7.33-2c-1.15-.2-2.24-.42-3.27-.53-.51-.07-1-.15-1.49-.19l-1.37-.12c-.88-.09-1.68-.1-2.38-.13s-1.3,0-1.8,0l-1.13,0A2.33,2.33,0,0,0,614.47,209.74Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Towing--inject-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "723.63 328.61 247.37 332.69 247.37 314.23 723.63 314.23 723.63 328.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.93,
    y: 302.6,
    width: 115.08,
    height: 48.53,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.14,
    y: 344.51,
    width: 589.32,
    height: 33.96,
    transform: "translate(793.6 722.98) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.81,184.91h21.5a0,0,0,0,1,0,0V355.5a0,0,0,0,1,0,0h-5.69a15.81,15.81,0,0,1-15.81-15.81V184.91a0,0,0,0,1,0,0Z",
    transform: "translate(469.13 540.41) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.12,268.83c.05-7,2.72-11.64,7.66-18.68l64-80.7a9.32,9.32,0,0,1,6.63-2.73h102a9.41,9.41,0,0,1,9.41,9.41V300.65a19.79,19.79,0,0,1-20.2,19.79h0c-87.48-12.54-103,54.89-103,54.89L35,374.19l-.87-98.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.08,259.26l7.52-.16,64-83.34-6-1s-42.72,53.17-60.71,76.7C38.5,254.55,37.36,257.29,36.08,259.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.94,185.44,123.87,185a8.17,8.17,0,0,0-6,2.69l-46.92,62a6.46,6.46,0,0,0,5,10.55l124-.18c4.58,0,8.3-4,8.3-9V194.43C208.19,189.48,204.5,185.47,199.94,185.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.68,
    y: 325.4,
    width: 491.75,
    height: 26.47,
    transform: "translate(949.1 677.28) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.28,367.53h11.59a4.46,4.46,0,0,0,4.46-4.46h0a4.46,4.46,0,0,0-4.46-4.47H661.28a4.47,4.47,0,0,0-4.46,4.47h0A4.46,4.46,0,0,0,661.28,367.53Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.79,398.12H239.33a9.82,9.82,0,0,0,9.82-9.82h0a9.82,9.82,0,0,0-9.82-9.83H59.79A9.83,9.83,0,0,0,50,388.3h0A9.82,9.82,0,0,0,59.79,398.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.92,
    y: 385.36,
    width: 263.89,
    height: 9.04,
    transform: "translate(741.73 779.76) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.61,
    y: 348.98,
    width: 135.91,
    height: 52.69,
    rx: 26.35,
    transform: "translate(689.14 750.66) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.79 283.25 275.91 214.12 258.61 215.07 257.61 316.67 726.26 320.07 726.14 287.44 301.79 283.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "726.26 308.15 257.66 309.09 257.61 295.55 726.26 296.29 726.26 308.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "569.33 296.05 552 308.37 568.68 308.32 585.71 296.07 569.33 296.05",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "532.67 296.11 515.33 308.43 532.01 308.39 549.04 296.13 532.67 296.11",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.11 295.93 478.59 308.55 495.27 308.51 512.78 295.96 496.11 295.93",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.61 295.87 441.89 308.64 458.57 308.6 475.88 295.9 459.61 295.87",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.24 295.81 405.22 308.73 421.87 308.69 439.72 295.84 423.24 295.81",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.38 295.76 368.48 308.82 385.16 308.78 402.95 295.78 386.38 295.76",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.05 295.7 331.77 308.91 348.46 308.87 366.51 295.73 350.05 295.7",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.62 295.64 295.07 309 311.76 308.96 329.7 295.67 313.62 295.64",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.87 295.58 258.75 309.1 275.43 309.06 293.16 295.61 276.87 295.58",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "603.07 295.97 585.69 308.39 602.37 308.35 619.64 296.13 603.07 295.97",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "636.74 296.15 619.56 308.37 635.89 308.39 653.12 296.19 636.74 296.15",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671.5 296.15 653.28 308.34 669.96 308.3 687.13 296.15 671.5 296.15",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "703.78 296.31 686.6 308.34 703.28 308.3 720.16 296.35 703.78 296.31",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.18,316.26s0-.38,0-1.12,0-1.86,0-3.3c0-2.92,0-7.19,0-12.7,0-11-.05-27-.08-46.67,0-9.86,0-20.65,0-32.24,0-5.79,0-11.79,0-18v-9.39c0-1.59,0-3.18,0-4.79a23.08,23.08,0,0,0-.23-4.79,9.4,9.4,0,0,0-6.2-6.82,14.45,14.45,0,0,0-4.9-.47H120.77a18.9,18.9,0,0,0-2.73.1,9.32,9.32,0,0,0-4.81,2.19,11.06,11.06,0,0,0-1.77,2l-1.64,2.19-3.25,4.34-6.43,8.59L75.61,228.17,64.19,243.4l-5.47,7.3a56.32,56.32,0,0,0-5,7.23A26.85,26.85,0,0,0,50.57,270c0,1.37,0,2.72,0,4.06q0,8.07,0,15.47c0,19.7-.08,35.65-.1,46.68,0,5.5,0,9.78-.05,12.69,0,1.44,0,2.55,0,3.3s0,1.13,0,1.13,0-.39,0-1.13,0-1.86,0-3.3c0-2.91,0-7.19,0-12.69,0-11,0-27-.07-46.67q0-7.4,0-15.47c0-1.35,0-2.71,0-4.08a27.89,27.89,0,0,1,.4-4.16,27.45,27.45,0,0,1,2.77-8.11,57.44,57.44,0,0,1,5-7.3l5.47-7.3q5.53-7.42,11.4-15.25l24.5-32.74,6.43-8.59,3.25-4.35,1.64-2.18a11.75,11.75,0,0,1,1.84-2.1,9.79,9.79,0,0,1,5.08-2.31,18.84,18.84,0,0,1,2.8-.11h83.84a14.71,14.71,0,0,1,5.06.5,9.88,9.88,0,0,1,6.51,7.18c.09.41.14.82.19,1.23s.06.84,0,1.24v7.21q0,4.77,0,9.39c0,6.17,0,12.17,0,18,0,11.59,0,22.38,0,32.24,0,19.7-.07,35.64-.09,46.67,0,5.51,0,9.78-.05,12.7,0,1.44,0,2.54,0,3.3S216.18,316.26,216.18,316.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47,262.76h0a8.21,8.21,0,0,1-8.21-8.22V225.2a8.21,8.21,0,0,1,8.21-8.22h0a8.22,8.22,0,0,1,8.22,8.22v29.34A8.22,8.22,0,0,1,108.47,262.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.18,273h-3V241.22a9.91,9.91,0,0,1,5.5-8.84c7.7-3.78,8.79-3.93,9.25-4l.42,3-.21-1.49.22,1.49c-.19,0-1.49.35-8.36,3.72a6.89,6.89,0,0,0-3.82,6.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.94,
    y: 250.18,
    width: 17.24,
    height: 3,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.06,281.44h0a5.77,5.77,0,0,1-5.77-5.78v-7.13a5.77,5.77,0,0,1,5.77-5.77h0a5.77,5.77,0,0,1,5.78,5.77v7.13A5.78,5.78,0,0,1,89.06,281.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,166.72H142.21a5.58,5.58,0,0,1,5.58-5.58h30.67a5.57,5.57,0,0,1,5.57,5.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72,161.14H150.57a11.89,11.89,0,0,1,11.88-11.89h3.38a11.89,11.89,0,0,1,11.89,11.89Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.62,200.43c.09.12-10.42,8.64-23.46,19s-23.7,18.74-23.79,18.63,10.41-8.64,23.46-19S184.53,200.32,184.62,200.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,215.11c.09.11-10.41,8.63-23.46,19s-23.7,18.74-23.79,18.63,10.41-8.63,23.46-19S178,215,178.1,215.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.49,388.3a50.57,50.57,0,1,1-50.57-50.58A50.57,50.57,0,0,1,225.49,388.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.49,388.17v.13a50.57,50.57,0,0,1-101.14,0c0-.05,0-.09,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.43,388.3a35.51,35.51,0,1,1-35.51-35.51A35.5,35.5,0,0,1,210.43,388.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.92,352.79a35.51,35.51,0,0,1,35.51,35.51h-71A35.5,35.5,0,0,1,174.92,352.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.55,388.3a21.63,21.63,0,1,1-21.63-21.63A21.63,21.63,0,0,1,196.55,388.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 536.07,
    cy: 388.17,
    r: 50.57,
    transform: "translate(92.74 879.6) rotate(-83.85)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.63,388s0,.08,0,.13a50.57,50.57,0,1,1-101.14,0V388Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.57,388.17a35.51,35.51,0,1,1-35.5-35.51A35.5,35.5,0,0,1,571.57,388.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.07,352.66a35.5,35.5,0,0,1,35.5,35.51h-71A35.51,35.51,0,0,1,536.07,352.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.7,388.17a21.63,21.63,0,1,1-21.63-21.63A21.63,21.63,0,0,1,557.7,388.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.2,350.25l-1.3,0-3.84,0-14.75.08-54.24.18-179,.42L224,351.28h-.15v-.15c0-14.23,0-25.49.07-33.2,0-3.84,0-6.8,0-8.8,0-1,0-1.75,0-2.27s0-.77,0-.77,0,.26,0,.77,0,1.28,0,2.27c0,2,0,5,0,8.8,0,7.71,0,19,.07,33.2L224,351l208.09-.51,179-.26,54.24,0,14.75,0h3.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.79,
    y: 353.34,
    width: 82.14,
    height: 27.36,
    rx: 8.51,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.29,380.7h-.53a8,8,0,0,1-1.53-.21,8.58,8.58,0,0,1-6.5-7.27c-.09-.79-.07-1.62-.08-2.47s0-1.74,0-2.66c0-1.83,0-3.8,0-5.88a8.74,8.74,0,0,1,8.8-9.08h7.87l17.35,0,39.78,0a8.74,8.74,0,0,1,8.25,5.82,8.21,8.21,0,0,1,.5,2.59c0,.87,0,1.7,0,2.55,0,1.7,0,3.37,0,5v2.48a10.56,10.56,0,0,1-.21,2.5,9,9,0,0,1-.87,2.34,9.69,9.69,0,0,1-1.49,2,8.8,8.8,0,0,1-4.22,2.33,10.11,10.11,0,0,1-2.38.23h-2.3l-32.49-.06-21.9-.08-6-.05-1.55,0-.53,0,.53,0,1.55,0,6-.05,21.9-.08,32.49-.05H102a9.07,9.07,0,0,0,2.27-.22,8.32,8.32,0,0,0,4-2.2,9.22,9.22,0,0,0,1.4-1.87,8.51,8.51,0,0,0,.82-2.21,10.44,10.44,0,0,0,.19-2.39V364a13.69,13.69,0,0,0-.49-5,8.12,8.12,0,0,0-3-3.95,8.31,8.31,0,0,0-4.78-1.53l-39.78,0-17.35,0H37.42a8.31,8.31,0,0,0-6.31,2.74A8.46,8.46,0,0,0,29,362.21c0,2.08,0,4.05,0,5.88,0,.92,0,1.81,0,2.66a24.08,24.08,0,0,0,.06,2.44,8.2,8.2,0,0,0,1.51,3.92,8.46,8.46,0,0,0,4.76,3.27A15.28,15.28,0,0,0,37.29,380.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.31,372.67H94a4.42,4.42,0,0,0,4.42-4.42h0A4.42,4.42,0,0,0,94,363.83H83.31a4.42,4.42,0,0,0-4.42,4.42h0A4.42,4.42,0,0,0,83.31,372.67Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.08,348h0V313.82h0a11.26,11.26,0,0,1,11.26,11.25v11.68A11.26,11.26,0,0,1,36.08,348Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71,249.87a5.42,5.42,0,0,1-.11-1.3c0-.95-.07-2.14-.11-3.57-.07-3-.13-7.16-.16-11.75,0-2.29,0-4.47,0-6.47a10.62,10.62,0,0,0-1-5,5.36,5.36,0,0,0-2.46-2.36,11.59,11.59,0,0,0-1.23-.37,1.3,1.3,0,0,1,.34,0,3.6,3.6,0,0,1,1,.2,5.31,5.31,0,0,1,2.7,2.37,10.76,10.76,0,0,1,1.18,5.19c0,2,0,4.19.08,6.48,0,4.59,0,8.74,0,11.75,0,1.43,0,2.62-.06,3.56A7.57,7.57,0,0,1,114.71,249.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.26,166.28c0,.14-15.85.26-35.4.26s-35.4-.12-35.4-.26,15.84-.26,35.4-.26S202.26,166.13,202.26,166.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.06,152.05c0,.09-.91-.16-2.36-.18a11.26,11.26,0,0,0-9.65,5c-.83,1.2-1.15,2.07-1.23,2a5.52,5.52,0,0,1,.92-2.23,10.68,10.68,0,0,1,10-5.13A5.49,5.49,0,0,1,166.06,152.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.81,280s.22,0,.6-.1a3.65,3.65,0,0,0,1.52-.74,3.46,3.46,0,0,0,1.23-2.28,3.38,3.38,0,0,0-1.35-3.05,3.29,3.29,0,0,0-1.86-.65h-2.3l-5.08,0-11.65,0a3.26,3.26,0,0,0-1.87,5.93,3.28,3.28,0,0,0,1.18.52,6.15,6.15,0,0,0,1.3.07l9.52.06,6.41.08,1.75.05a4.13,4.13,0,0,1,.6.05,2.41,2.41,0,0,1-.6.06l-1.75,0-6.41.09-9.52.05a6.17,6.17,0,0,1-1.4-.08,3.81,3.81,0,0,1-1.36-.58,3.77,3.77,0,0,1-1.58-2.54,3.76,3.76,0,0,1,3.73-4.32l11.65,0,5.08,0,2.31,0a3.65,3.65,0,0,1,2.1,6.54,3.38,3.38,0,0,1-1.63.68A2,2,0,0,1,198.81,280Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.81,
    y: 284.57,
    width: 75.11,
    height: 23.18,
    rx: 7.39,
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.88,293.57c0,.14-11.94.26-26.65.26s-26.65-.12-26.65-.26,11.93-.26,26.65-.26S162.88,293.42,162.88,293.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.78,298.76c0,.14-8.79.26-19.62.26s-19.61-.12-19.61-.26,8.78-.26,19.61-.26S157.78,298.61,157.78,298.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.63,328.61l-1.24,0-3.63,0-14,0-51.32-.07c-43.33-.15-103.19-.63-169.3-1.28s-126-1.2-169.33-1.43l-51.31-.25-14-.06-3.63,0-1.24,0s.42,0,1.24,0l3.63,0,14,0,51.31.08c43.34.14,103.2.62,169.33,1.28s126,1.19,169.3,1.43l51.32.24,14,.06,3.63,0Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.39,434.35l-.05,12.43S291,451,291.17,453.3l-24.1.77-.72-19.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.85,446a1,1,0,0,0-.64,1.15,1,1,0,0,0,1.13.65,1,1,0,0,0,.67-1.22,1,1,0,0,0-1.25-.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.07,454.07v-1.95h23.11s1.09.43,1,1.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.72,446.65c0,.11-.58.19-1.15.58s-.86.9-1,.86,0-.73.74-1.2S278.75,446.54,278.72,446.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.29,447.61c0,.11-.48.33-.86.84s-.48,1-.6,1-.21-.66.27-1.29S281.28,447.5,281.29,447.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.82,450.59c-.11,0-.29-.55,0-1.21s.82-.93.88-.83-.28.45-.5,1S282.93,450.58,282.82,450.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.42,443.81c0,.11-.59,0-1.25,0s-1.18.29-1.24.2.42-.54,1.2-.61S278.48,443.72,278.42,443.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.46,436.78l-.67,15,2.89,12a1.54,1.54,0,0,1-1.24,1.88h0a1.51,1.51,0,0,1-1.34-.42c-2.25-2.25-10.25-10.68-10.28-11.49-.06-1.27-.43-16.07-.43-16.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44,465.71l-11.68-13.1v.63a2.42,2.42,0,0,0,.52,1.52c.93,1.14,3.56,4.24,9.78,10.53a1.56,1.56,0,0,0,1.39.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242,447.82a1,1,0,0,1,.23,1.23.89.89,0,0,1-1.21.23,1,1,0,0,1-.23-1.29.93.93,0,0,1,1.28-.11",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.15,459.07a4.52,4.52,0,0,1,1.34-1.14,4.63,4.63,0,0,1,1.74-.29s-.17-.16-.52-.22a2.42,2.42,0,0,0-1.36.21,2.45,2.45,0,0,0-1,.9C247.14,458.84,247.11,459.06,247.15,459.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.18,461.11a11.67,11.67,0,0,1,1.34-.62c.78-.22,1.45-.06,1.48-.16a1.74,1.74,0,0,0-1.56-.16C248.54,460.41,248.1,461.06,248.18,461.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.21,456.45a15.39,15.39,0,0,1,2-1.1,15.91,15.91,0,0,1,2.24-.47,3.45,3.45,0,0,0-2.36.16A3.4,3.4,0,0,0,245.21,456.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,451.86c0,.09.87-.24,2-.25s1.94.26,2,.17a3,3,0,0,0-2-.5A3,3,0,0,0,245,451.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.12,447.45a7.39,7.39,0,0,1,2-.32,7.83,7.83,0,0,1,2,.54s-.13-.22-.47-.43a3.37,3.37,0,0,0-1.49-.44,3.33,3.33,0,0,0-1.53.27C245.28,447.24,245.1,447.41,245.12,447.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.14,446.29a1.29,1.29,0,0,0,0-.57,4.09,4.09,0,0,0-.42-1.5,1.78,1.78,0,0,0-.74-.85.62.62,0,0,0-.7.12,1,1,0,0,0-.25.68,2.17,2.17,0,0,0,1.86,2.05,2.51,2.51,0,0,0,2.51-1.27.86.86,0,0,0,.06-.72.61.61,0,0,0-.63-.34,2.23,2.23,0,0,0-1,.49,4.34,4.34,0,0,0-1.05,1.15,1.21,1.21,0,0,0-.24.51,7,7,0,0,1,1.43-1.47,2.09,2.09,0,0,1,.88-.41.35.35,0,0,1,.35.18.65.65,0,0,1-.07.48,2.24,2.24,0,0,1-2.19,1.07,1.89,1.89,0,0,1-1.61-1.72.81.81,0,0,1,.16-.48.35.35,0,0,1,.39-.07,1.67,1.67,0,0,1,.63.71A5.57,5.57,0,0,1,247.14,446.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.16,238.44l3.46,28c.32,4.55,2.6,7.88,7.16,7.88h0a8.67,8.67,0,0,0,8.65-9.24c-.17-2.65-.33-4.82-.33-4.82s6.74-1,6.82-7.78c.05-3.89-.62-12.71-1.2-19.48a8.83,8.83,0,0,0-8.8-8.08h-4.07A12.47,12.47,0,0,0,255.16,238.44Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.1,260.26a16.28,16.28,0,0,1-8.77-2.59s2.17,4.9,8.89,4.29Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.46,239.43c-.12.13-.85-.41-1.88-.41s-1.8.52-1.91.4.07-.29.4-.53a2.64,2.64,0,0,1,1.52-.47,2.52,2.52,0,0,1,1.5.49C278.41,239.15,278.52,239.38,278.46,239.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.23,242.31a1,1,0,0,1-.92,1,.91.91,0,0,1-1-.87,1,1,0,0,1,.92-1A.91.91,0,0,1,269.23,242.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.47,242.31a1,1,0,0,1-.92,1,.91.91,0,0,1-1-.87,1,1,0,0,1,.92-1A.91.91,0,0,1,278.47,242.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.46,239.57c-.11.13-.84-.41-1.88-.41s-1.79.52-1.9.4.06-.29.39-.53a2.67,2.67,0,0,1,1.53-.47,2.54,2.54,0,0,1,1.5.49C268.41,239.29,268.52,239.52,268.46,239.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.15,247.62a7.11,7.11,0,0,1,1.68-.3c.26,0,.51-.08.56-.26a1.35,1.35,0,0,0-.18-.78l-.78-2a35.35,35.35,0,0,1-1.76-5.27,34.84,34.84,0,0,1,2.18,5.11l.75,2a1.48,1.48,0,0,1,.13,1,.66.66,0,0,1-.43.39,2,2,0,0,1-.45.06A6.34,6.34,0,0,1,272.15,247.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.1,248.34c.17,0,.17,1.11,1.13,1.91s2.16.68,2.17.83-.27.22-.77.23a2.77,2.77,0,0,1-1.81-.63,2.41,2.41,0,0,1-.88-1.6C268.9,248.61,269,248.33,269.1,248.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.41,236.94c-.1.28-1.13.15-2.35.3s-2.19.48-2.35.22.09-.38.49-.66a4.11,4.11,0,0,1,3.59-.39C268.23,236.59,268.46,236.81,268.41,236.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.32,236.9c-.19.23-.9,0-1.76,0s-1.58.15-1.75-.09,0-.36.36-.58a2.42,2.42,0,0,1,1.42-.38,2.38,2.38,0,0,1,1.4.47C278.3,236.54,278.4,236.78,278.32,236.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.43,243.49c-.11-.05-4.63-1.37-4.48,3.24s4.74,3.5,4.74,3.37S257.43,243.49,257.43,243.49Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.23,248.4s-.08.06-.21.13a.84.84,0,0,1-.6,0,2,2,0,0,1-1-1.75,2.73,2.73,0,0,1,.19-1.16.91.91,0,0,1,.59-.63.4.4,0,0,1,.48.2c.06.13,0,.22.06.23s.1-.08.05-.27a.49.49,0,0,0-.19-.28.59.59,0,0,0-.44-.11,1.14,1.14,0,0,0-.82.74,2.88,2.88,0,0,0-.24,1.3,2.1,2.1,0,0,0,1.24,1.95.9.9,0,0,0,.73-.15C256.23,248.51,256.25,248.41,256.23,248.4Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.87,243.33a2.43,2.43,0,0,1,2.22,1.14c.3.66.36,1.4.66,2.06a1.64,1.64,0,0,0,1.68,1.09,1.44,1.44,0,0,0,1-1.05,4.14,4.14,0,0,0,0-1.49c-.27-2.15-.72-4.28-.81-6.45a11,11,0,0,1,1.36-6.26,6,6,0,0,1,5.38-3c1.44.11,2.75.86,4.17,1.06a5.64,5.64,0,0,0,4.67-1.56,10.32,10.32,0,0,1,.88-.63,2.68,2.68,0,0,0-.49-1.43c-2.82-2.6-7.9-3.33-11.63-2.39a13.43,13.43,0,0,0-8.82,7c-1.6,3.5-1.12,8.35-.24,11.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.51,228.89c-2.55.11-7.4,1.07-9.41,2.65-.24.18-.5.49-.34.75s.4.2.63.19a34.62,34.62,0,0,1,6.92,1,12.12,12.12,0,0,0,4.49.65,4.37,4.37,0,0,0,3.66-2.36l.65.24A7.51,7.51,0,0,0,274.51,228.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.8,232a8.67,8.67,0,0,0-5-2.26A20.38,20.38,0,0,0,254.39,241a23,23,0,0,1-1-5.33c0-1.37.82-9.53,9.22-12.09C262.56,223.6,275.2,218.77,279.8,232Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280,232a8.21,8.21,0,0,0-5.61-2.55c-5.21-.23-15.06,2.16-19.79,11.61a23,23,0,0,1-1.05-5.33c0-1.37.82-9.53,9.21-12.09C262.72,223.6,275.37,218.77,280,232Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M255.18,239.59c2.51-4.23,6.28-7.14,10.34-9.67a65,65,0,0,1,15.4-6.28,10.15,10.15,0,0,1,4.26-.45,3.83,3.83,0,0,1,3.15,2.59c.44,1.74-2.65,4.43-4.11,5.49a46.68,46.68,0,0,1-4.42,2.61s0-3.24-5.14-3.9C267.59,229.09,255,239.77,255.18,239.59Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.58,227a25.15,25.15,0,0,1,4.72-1.86,26.19,26.19,0,0,1,5-.51,4.79,4.79,0,0,0-1.5-.2,13.66,13.66,0,0,0-3.62.37,13.12,13.12,0,0,0-3.4,1.34A5,5,0,0,0,264.58,227Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.69,262s-15.62,5.84-16.64,6.35,4.66,37.05,4.66,37.05l-1.55,30s26.45,2.71,33.28,1.17a42,42,0,0,0,10.36-3.5l-2.66-42.46-2.6-21.45-8.18-5.28C269.22,267.67,264.71,266.45,257.69,262Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.14 289.53 290.73 304.82 285.78 304.82 285.59 290.71 289.14 289.53",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.17,269a11.89,11.89,0,0,1,5.9,7c1.37,4.92,2,14.66,2,14.66h-5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.67,277.43a4.36,4.36,0,0,1,.11.83c.06.53.12,1.3.19,2.26.14,1.91.3,4.55.42,7.47s.18,5.56.18,7.48c0,.95,0,1.73,0,2.26a4.74,4.74,0,0,1-.06.84,4,4,0,0,1-.07-.83c0-.61-.05-1.37-.08-2.27-.08-2-.18-4.59-.28-7.47s-.24-5.48-.32-7.47c0-.9-.06-1.66-.08-2.27A3.38,3.38,0,0,1,284.67,277.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.8,329s.52,10.13.22,18.77c-.11,3.35-7.45,96.07-7.45,96.07l-15.19.64.59-86.88-1.23.33s-6.73,37.32-7.15,43.34c-.38,5.41-5.72,44.8-5.72,44.8L238,446.8l2.24-51.9,2.62-50L244,329.74l8.37-.14Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.46,344.16s.19,0,.52.06a9.22,9.22,0,0,0,1.43,0,13.74,13.74,0,0,0,8.38-4,9.13,9.13,0,0,0,.94-1.07c.2-.27.3-.42.28-.44s-.51.55-1.38,1.35a15.27,15.27,0,0,1-3.83,2.57,15.59,15.59,0,0,1-4.42,1.32C244.21,344.12,243.46,344.11,243.46,344.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.14,336.62a6.4,6.4,0,0,0,.85,1.52,17.54,17.54,0,0,0,2.78,3.16,17.72,17.72,0,0,0,3.45,2.4,6.3,6.3,0,0,0,1.6.67s-.58-.33-1.49-.87a22.05,22.05,0,0,1-3.35-2.44,22.65,22.65,0,0,1-2.8-3.05A16.37,16.37,0,0,0,280.14,336.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.92,400.14a72.48,72.48,0,0,0,5.7-7.06,36.77,36.77,0,0,0-3,3.45A39.5,39.5,0,0,0,245.92,400.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.23,394.22a13.32,13.32,0,0,0,1.48,2.33,13.71,13.71,0,0,0,1.71,2.17,14.09,14.09,0,0,0-1.48-2.33A14.42,14.42,0,0,0,276.23,394.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.6 283.56 250.64 329.78 287.8 328.98 282.98 283.56 256.6 283.56",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.71,266.54s6.48.68,8.54,5.77A66.71,66.71,0,0,1,257.83,285a1.71,1.71,0,0,0,1.7,1.5h0a1.7,1.7,0,0,0,1.69-1.86c-.33-4-2.07-12.15-5-15.67a10.54,10.54,0,0,0-6.93-3.84Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.93 266.88 279.61 285.32 282.24 285.32 281.68 268.37 278.93 266.88",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27,279.24S245.6,300,247,293.9c.89-3.83-1.34,10.12-1.34,10.12l20.89-1,2.7,7.91s-24.7,6.89-28.43,7A9.77,9.77,0,0,1,231.12,307c.85-6.15,5.32-27.71,5.32-27.71Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.06,303.63a35.58,35.58,0,0,1,3.33-1.91l1.38-.32a1.88,1.88,0,0,1,1.56.31.89.89,0,0,1,.42.74c-.05.57-.9,1-.9,1l-1.52.55,3.76,2s5.21,3.33,5.28,4.33a2.84,2.84,0,0,1-.44,2.14,4.5,4.5,0,0,1-1.77.55s-.55,1.41-1.21,1.52a14.81,14.81,0,0,1-2.86-.37l-3.48-1.27-4-4.89-.18-3.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.52,310.21a43.32,43.32,0,0,0-.63-4.74c-.23-.4-12.79-1-12.79-1l-8.8,1.26s-.62,3.14,0,4.79,5.89,3.2,5.89,3.2Z",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.46,312.9a8,8,0,0,1-.16-1.72c0-.52,0-1.18-.1-1.85a2.07,2.07,0,0,0-1.42-1.44c-.73-.31-1.49-.48-2.15-.75l-1.75-.68a9.27,9.27,0,0,1-1.58-.7,8.17,8.17,0,0,1,1.67.47l1.76.61c.65.25,1.42.4,2.18.73a3.51,3.51,0,0,1,1.06.66,1.73,1.73,0,0,1,.54,1.06,17.74,17.74,0,0,1,0,1.88A8.27,8.27,0,0,1,282.46,312.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.7,305.81a14.68,14.68,0,0,1-2.13.43l-5.15.9-5.13,1a15,15,0,0,1-2.15.34,12.38,12.38,0,0,1,2.1-.58c1.3-.31,3.11-.7,5.12-1.06s3.85-.64,5.18-.81A12.4,12.4,0,0,1,296.7,305.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.11 303.61 281.11 304.5 284.67 304.34 284.67 303.55 281.11 303.61",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.56 304.43 282.56 306.33 283.39 306.16 283.39 304.4 282.56 304.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.09,306.06c0,.1-.51.26-1.17.37s-1.22.13-1.24,0,.51-.26,1.18-.37S284.08,306,284.09,306.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.54 303.3 286.54 304.07 289.63 303.93 289.63 303.25 286.54 303.3",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.8 304.01 287.8 305.66 288.52 305.51 288.52 303.99 287.8 304.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.13,305.42c0,.1-.44.25-1,.35s-1.05.09-1.07,0,.44-.25,1-.34S289.11,305.33,289.13,305.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,302l-2.73-1.27-6.6.63L266.57,303l1.33,7.44,4.3,4.3,7.14.43L281,314s3.3,0,3.3-.37.53-1.09.25-1.27a17.2,17.2,0,0,0-2.83-.24l-3.2-2.67s-2.91-2.78-2.73-3.87.17-1.2.89-1.57a17.85,17.85,0,0,1,2.32-.79s2.24.85,3,.48.49-1.45.49-1.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.65,310.68s.3.21.72.6a14.44,14.44,0,0,0,1.68,1.42,6.72,6.72,0,0,0,1.94.95c.54.16.89.18.89.24a1.69,1.69,0,0,1-.94,0,5.19,5.19,0,0,1-2.09-.91,9.11,9.11,0,0,1-1.66-1.53A2.58,2.58,0,0,1,275.65,310.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.66,311.86c.06-.08,1.26.78,2.85,1.62s3,1.36,2.95,1.45a12.26,12.26,0,0,1-5.8-3.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.12,303.83a5.23,5.23,0,0,1,2.42-1.81,5.29,5.29,0,0,1,3-.49,25.45,25.45,0,0,0-2.84.81A22.46,22.46,0,0,0,286.12,303.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.38,311.16s.2.21.59.51a3.59,3.59,0,0,0,1.81.73l-.06.3c-.68-.17-1.45-.37-2.28-.55a11.41,11.41,0,0,0-3.59-.3,1.69,1.69,0,0,0-.92.47c-.17.19-.22.33-.25.32a.6.6,0,0,1,.15-.4,1.63,1.63,0,0,1,1-.63,9.69,9.69,0,0,1,3.71.2c.84.18,1.62.4,2.29.59l-.06.31a3.41,3.41,0,0,1-1.89-.9C294.48,311.45,294.35,311.17,294.38,311.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05,268.37a19.32,19.32,0,0,0-5.46,9.06c-1.88,6.2-3.74,13.45-3.74,13.45l17.44,3.39s.48-3.08,1.34-8.67C252.74,271.93,244.12,268.54,241.05,268.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,308a28.18,28.18,0,0,1,2.83-2.06,25.28,25.28,0,0,1,2.88-2,13.66,13.66,0,0,1-2.68,2.27A12.6,12.6,0,0,1,240,308Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.85,290.88A7.35,7.35,0,0,1,233,291l3,.53c2.54.46,6.05,1.12,9.92,1.87l3.43.67-.2.15,1-7.66c.14-.9.24-1.65.33-2.23a4,4,0,0,1,.16-.8,4.55,4.55,0,0,1,0,.82c-.05.58-.13,1.33-.22,2.24-.23,2-.54,4.62-.9,7.67l0,.18-.18,0-3.43-.66c-3.87-.75-7.37-1.45-9.9-2l-3-.64A7.45,7.45,0,0,1,231.85,290.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.36,277.43c-.06,0-.09-.82-.48-2.07a9.84,9.84,0,0,0-7.06-6.66c-1.27-.31-2.1-.3-2.09-.36a1.62,1.62,0,0,1,.57,0,7.64,7.64,0,0,1,1.57.18,9.4,9.4,0,0,1,7.24,6.83,8,8,0,0,1,.27,1.55A1.66,1.66,0,0,1,252.36,277.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.23 302.65 263.54 312.9 268.6 311.16 266.57 303.01 261.23 302.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.78 365.35 240.28 369.87 252.65 369.87 252.65 366.3 241.78 365.35",
    style: {
      fill: "#338E40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.78,365.35a3.19,3.19,0,0,1,.74-.06l2.18-.07c1.88-.05,4.57-.09,7.72-.11h.24v.23c.07,1.41.16,2.93.24,4.51l0,.28h-1.26c-4.45,0-8.47,0-11.39-.08H240l.08-.24c.5-1.42.92-2.55,1.2-3.32a7.13,7.13,0,0,1,.48-1.14,9.14,9.14,0,0,1-.33,1.29c-.23.79-.57,1.92-1,3.28l-.17-.24c2.92,0,6.94-.07,11.39-.07h1l-.26.27c-.07-1.59-.14-3.11-.21-4.51l.24.23c-3.07,0-5.7-.06-7.59-.11l-2.22-.07A3.57,3.57,0,0,1,241.78,365.35Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowingPana);
export default __webpack_public_path__ + "static/media/Towing-pana.9b277d15606a6a2763cb7fb5e46e6a93.svg";
export { ForwardRef as ReactComponent };